import { useNode } from '@craftjs/core';
import { ImagePreview } from './ImagePreview';
import type { ImageProps } from '@builder4/shared/components/Image';
import { useBreakpointAwareProp } from '@/hooks/useBreakpointAwareProp';
import { useImageManager } from '@/hooks/useImageManager';
import type { AssetResponse } from '@lp/lib-asset-api';

const NodeImagePreviewSettings = () => {
  const { openImageManager } = useImageManager();

  const {
    actions: { setProp },
    props,
    displayName,
  } = useNode((node) => ({
    props: node.data.props,
    displayName: node.data.displayName,
  }));

  const { getBPProp, setBPProp } = useBreakpointAwareProp(displayName);

  const handleSelectImage = (image: AssetResponse) => {
    setProp((props: Partial<ImageProps>) => {
      setBPProp(props, 'id', image._meta.id);
      setBPProp(props, 'src', image.fileUri);
      setBPProp(props, 'alt', image.metadata.altText);
    });
  };

  const handleRemoveClick = () => {
    setProp((props: Partial<ImageProps>) => {
      setBPProp(props, 'id', '');
      setBPProp(props, 'src', '');
      setBPProp(props, 'alt', '');
    });
  };

  const imageId = getBPProp(props, 'id');
  const src = getBPProp(props, 'src');

  const handleReplaceClick = () => {
    openImageManager({ onSelectImage: handleSelectImage, activeImageId: imageId });
  };

  return (
    <ImagePreview
      image={src ?? null}
      onReplaceClick={handleReplaceClick}
      onRemoveClick={handleRemoveClick}
    />
  );
};

export default NodeImagePreviewSettings;
